"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.messages = void 0;

var _reactIntl = require("react-intl");

var messages = (0, _reactIntl.defineMessages)({
  title: {
    "id": "access-denied-page.title",
    "defaultMessage": "Access is Denied"
  },
  accessDenied: {
    "id": "access-denied-page.accessDenied",
    "defaultMessage": "The currently logged in user does not have an access rights to view this page."
  },
  previousPage: {
    "id": "access-denied-page.previousPage",
    "defaultMessage": "Previous page"
  },
  homepage: {
    "id": "access-denied-page.homepage",
    "defaultMessage": "Homepage"
  }
});
exports.messages = messages;
//# sourceMappingURL=sb-access-denied-page-i18n.js.map